// extracted by mini-css-extract-plugin
module.exports = {"root":"Code_root__j-DSW","javascript":"Code_javascript__30DY4"};